import React, { useEffect, useState } from "react";
import { ValidationMessage } from "../../components/Utils";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  INCOME_CATEGORY_EDIT,
  INCOME_CATEGORY_UPDATE
} from "../../routes/routes";
import { toast } from "react-toastify";
import { FullPageLoader } from '../../components/common/Loader';

const EditIncomeCategory = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ name: "" });
  const [errors, setErrors] = useState({});

  const submit = () => {
    setBtnDisabled(true);
    let requestBody = { ...form };
    axios
      .put(INCOME_CATEGORY_UPDATE + id, requestBody)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success("Income Category updated successfully");
          navigate("/income-category");
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 422) {
          const error = err.response.data.error;
          setErrors(error);
          toast.error(err.response.data.msg);
        } else {
            toast.error("Something went wrong");
        }
      }).finally(() => {
        setBtnDisabled(false);
      });
  };

  useEffect(() => {
    setLoading(true);
    axios.get(INCOME_CATEGORY_EDIT + id).then((res) => {
      if (res.status === 200 && res.data.success) {
        let responseData = res.data.data;
        setForm({
          id: responseData?.id,
          name: responseData?.name,
          amount: responseData?.amount,
          status: responseData?.status
        });
      }
    }).finally(() => {
      setLoading(false);
    });
  }, [id]);

  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Income Category</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li>
                  <Link to={"/income-category"}>
                    <span>Income Category List</span>
                  </Link>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li><span className="active_breadcrumb">Edit Income Category</span></li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/income-category"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-body">
                <form>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="name">
                          Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          placeholder="Name"
                          onChange={(e) =>
                            setForm({ ...form, name: e.target.value })
                          }
                          onBlur={(e) =>
                             setForm({ ...form, name: e.target.value })
                          }
                          value={form?.name}
                        />
                        <ValidationMessage error={errors} name="name" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="amount">
                          Amount<span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="amount"
                          placeholder="Amount"
                          onChange={(e) =>
                            setForm({ ...form, amount: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, amount: e.target.value })
                          }
                          value={form?.amount}
                        />
                        <ValidationMessage error={errors} name="amount" />
                      </div>
                    </div>

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/income-category"}>
                        <button type="button" className="btn btn-primary iclose_btn">
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="submit"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditIncomeCategory;
